import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNav from '../components/BottomNav';
import RecordFAB from '../components/RecordFAB';
import { patientPath } from '../constants/routes';
import { useShift } from '../contexts/ShiftContext';
import { useSession } from '../contexts/SessionContext';

export default function AppShell({ children, showFab = false }) {
  const { isOnShift } = useShift();
  const { toast, clearToast } = useSession();
  const navigate = useNavigate();
  const withFab = showFab && isOnShift;

  useEffect(() => {
    if (!toast) return undefined;
    const timer = window.setTimeout(() => clearToast(), 3000);
    return () => window.clearTimeout(timer);
  }, [clearToast, toast]);

  return (
    <div className="min-h-screen bg-page">
      {children}
      {toast && (
        <button
          type="button"
          onClick={() => {
            if (toast.patientId) {
              navigate(patientPath(toast.patientId), { state: { taskTab: 'all' } });
            }
            clearToast();
          }}
          className="fixed left-4 right-4 top-4 z-[300] rounded-xl bg-primary px-4 py-3 text-left text-sm font-semibold text-white shadow-lg"
        >
          {toast.message}
        </button>
      )}
      <div
        aria-hidden="true"
        className={withFab ? 'h-safe-nav-fab shrink-0' : 'h-safe-nav shrink-0'}
      />
      {showFab && <RecordFAB />}
      <BottomNav />
    </div>
  );
}
